import actions from './actions';
import mutations from './mutations';

const state = {
  appliedUpdates: {},
  appliedUpdateIds: [],
  complispacePublished: {},
  complispacePublishedIds: []
};

const getters = {
  appliedItems: (stateData) => stateData.appliedUpdateIds.map((id) => stateData.appliedUpdates[id]),
  complispaceItems: (stateData) =>
    stateData.complispacePublishedIds.map((id) => stateData.complispacePublished[id]),
  getAppliedPublished: (stateData) => (id) => stateData.appliedUpdates[id],
  getComplispacePublished: (stateData) => (id) => stateData.complispacePublished[id]
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
